import { useCssVars as _useCssVars } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "links-col"
};
const _hoisted_2 = {
  class: "product-desc"
};
const _hoisted_3 = {
  class: "product-name"
};
const _hoisted_4 = {
  key: 0,
  class: "product-tagline"
};
const _hoisted_5 = {
  class: "link-arrow"
};
import { computed, inject } from "vue";
import { Right } from '@element-plus/icons-vue';
const minRowsBeforeColumns = 6; // Ideally should match number of AT Products, but should remain flexible

export default {
  __name: 'NavBarProductLinksList',
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  setup(__props) {
    _useCssVars(_ctx => ({
      "d380790a": props.items.length,
      "f43b3540": numColumns.value,
      "3eac0671": midpoint.value
    }));
    const closeNavBar = inject("closeNavBar", () => {});
    const props = __props;
    const midpoint = computed(() => {
      if (props.items.length < minRowsBeforeColumns) {
        return props.items.length;
      }
      if (props.items.length <= 10) {
        return minRowsBeforeColumns;
      }
      return Math.ceil(props.items.length / 2);
    });
    const numColumns = computed(() => {
      if (props.items.length <= minRowsBeforeColumns) {
        return 1;
      }
      return 2;
    });
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (edition, index) => {
        return _openBlock(), _createBlock(_component_router_link, {
          key: index,
          to: edition.destination,
          class: "product-link",
          onClick: _unref(closeNavBar)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(edition.name), 1), edition.description ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(edition.description), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, [_createVNode(_unref(Right), {
            class: "el-icon"
          })])]),
          _: 2
        }, 1032, ["to", "onClick"]);
      }), 128))]);
    };
  }
};